import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import UserAvatar from '../../../../User/Avatar';
import UserIcon from '@wix/da-ds/pkg/Icons/User';
import userMenuStyles from './UserMenu.scss';
const UserMenuAvatar = ({ currentUser, isUserMenuOpened, onToggleUserMenu, tabIndex })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, currentUser ? /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        onClick: onToggleUserMenu,
        className: classnames(userMenuStyles['avatar-wrapper'], isUserMenuOpened && userMenuStyles['with-menu-open']),
        "aria-label": t('siteHeader.userMenu.a11y.label'),
        "aria-expanded": isUserMenuOpened,
        tabIndex: tabIndex
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        user: currentUser,
        size: 32,
        className: userMenuStyles['avatar'],
        withLink: false,
        withTooltip: false,
        enableLazyLoad: false
    })) : /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        onClick: onToggleUserMenu,
        className: classnames(userMenuStyles['avatar-wrapper'], isUserMenuOpened && userMenuStyles['with-menu-open']),
        "aria-label": t('siteHeader.userMenu.a11y.label'),
        "aria-expanded": isUserMenuOpened,
        tabIndex: tabIndex
    }, /*#__PURE__*/ React.createElement(UserIcon, {
        className: classnames(userMenuStyles['anon-user-icon'], isUserMenuOpened && userMenuStyles['is-dark']),
        size: IconSize.MEDIUM,
        withPadding: true
    })));
};
UserMenuAvatar.displayName = 'UserMenuAvatar';
export default UserMenuAvatar;
